import type { FortuneIconProps } from '@/app_components/icons/constants';

export const LinkedIn = ({ className, ...props }: FortuneIconProps) => {
  return (
    <svg
      className={className}
      height='20'
      stroke='none'
      viewBox='0 0 20 20'
      width='20'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <title>LinkedIn icon</title>
      <mask
        height='20'
        id='mask0_279_37832'
        maskUnits='userSpaceOnUse'
        style={{ maskType: 'alpha' }}
        width='20'
        x='0'
        y='0'
      >
        <rect
          fill='#D9D9D9'
          height='20'
          width='20'
        />
      </mask>
      <g mask='url(#mask0_279_37832)'>
        <path
          d='M15.8333 0H4.16667C3.0616 0 2.00179 0.438987 1.22039 1.22039C0.438987 2.00179 0 3.0616 0 4.16667L0 15.8333C0 16.3805 0.107774 16.9223 0.317169 17.4278C0.526563 17.9334 0.833478 18.3927 1.22039 18.7796C2.00179 19.561 3.0616 20 4.16667 20H15.8333C16.3805 20 16.9223 19.8922 17.4278 19.6828C17.9334 19.4734 18.3927 19.1665 18.7796 18.7796C19.1665 18.3927 19.4734 17.9334 19.6828 17.4278C19.8922 16.9223 20 16.3805 20 15.8333V4.16667C20 3.61949 19.8922 3.07768 19.6828 2.57215C19.4734 2.06663 19.1665 1.6073 18.7796 1.22039C18.3927 0.833478 17.9334 0.526563 17.4278 0.317169C16.9223 0.107774 16.3805 0 15.8333 0V0ZM6.66667 15.8333H4.16667V6.66667H6.66667V15.8333ZM5.41667 5.61C4.61167 5.61 3.95833 4.95167 3.95833 4.14C3.95833 3.32833 4.61167 2.67 5.41667 2.67C6.22167 2.67 6.875 3.32833 6.875 4.14C6.875 4.95167 6.2225 5.61 5.41667 5.61ZM16.6667 15.8333H14.1667V11.1633C14.1667 8.35667 10.8333 8.56917 10.8333 11.1633V15.8333H8.33333V6.66667H10.8333V8.1375C11.9967 5.9825 16.6667 5.82333 16.6667 10.2008V15.8333Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
};
